module.exports = __webpack_public_path__ + "static/media/banner-without-margin.6652105f.webp";